import React from 'react';
import { NavProvider } from '../../context/nav-context';
import Masthead from '../masthead';
import Nav from '../nav/nav';
import TopNav from '../nav/top-nav/top-nav';
import SubNav from '../nav/sub-nav/sub-nav';
import MegaNav from '../nav/mega-nav/mega-nav';
import OffersNav from '../nav/offers-nav/offers-nav';
import HamburgerNav from '../nav/hamburger-nav';

import Notification from '@/components/shared/notification';
import { useIntl } from 'react-intl';

interface HeaderProps {
  hasError?: boolean;
}

const Header: React.FC<HeaderProps> = ({ hasError }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {hasError ? <Notification message={formatMessage({ id: 'genericError' })} type="error" /> : null}
      <div data-testid="header">
        <NavProvider navId={'show-plp'}>
          <Masthead />
          <Nav>
            <TopNav />
            <SubNav />
            <MegaNav />
            <OffersNav />
          </Nav>
          <HamburgerNav />
        </NavProvider>
      </div>
    </>
  );
};

export default Header;
